<template>
  <vac ref="countdown" :end-time="endTime" class="valeur_timer" @finish="restartVac">
    <span slot="process" slot-scope="{ timeObj }">
      {{ `${timeObj.h}:${timeObj.m}:${timeObj.s}` }}
    </span>
    <span slot="finish">00:00:00</span>
  </vac>
</template>

<script>
export default {
  name: 'CompteARebours',
  props: ['dateHeureFin'],
  data() {
    return {};
  },
  computed: {
    endTime() {
      return this.dateHeureFin;
    },
  },
  methods: {
    restartVac() {
      const currentVac = this;

      setTimeout(function () {
        if (currentVac.dateHeureFin) {
          currentVac.$refs.countdown?.startCountdown(true);
        }
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.valeur_timer {
  font-variant-numeric: tabular-nums; //permet d'avoir la meme taille pour tous les chiffres
  font-feature-settings: 'tnum'; //Support pour browsers legacy
}
</style>
